import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { formatNumberWithCommas } from 'helper';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';

function PropertyAppraisalTab({
  isLoading,
  getFloorPlanLogs,
  floorAreaList,
  historyInfo,
  getPropertyAppraisalLogs,
  historyList,
  showPropertyAppraisalLogs
}) {

  const [formData, setFormData] = useState({});

  const OnSetFormData = () => {
    setFormData({
      cost_of_additional_item_sub_total: _.get(historyList, '0.attributes.cost_of_additional_item_sub_total'),
      sub_total_adjustment: _.get(historyList, '0.attributes.sub_total_adjustment'),
      total_construction_cost: _.get(historyList, '0.attributes.total_construction_cost'),
      depreciation_rate: _.get(historyList, '0.attributes.depreciation_rate'),
      depreciation_cost: _.get(historyList, '0.attributes.depreciation_cost'),
      total_percent_depreciation: _.get(historyList, '0.attributes.total_percent_depreciation'),
      market_value: _.get(historyList, '0.attributes.market_value'),
    });
    showPropertyAppraisalLogs(historyInfo.id, _.get(historyList, '0.id'));
  };

  useEffect(() => {
    if (_.isEmpty(historyInfo)) return;
    getPropertyAppraisalLogs(historyInfo.id)
  }, []);

  useEffect(() => {

    if (_.isEmpty(historyInfo)) return;
    getPropertyAppraisalLogs(historyInfo.id)
    getFloorPlanLogs(historyInfo.id)

  }, [historyInfo]);

  useEffect(() => {
    if (!_.isEmpty(historyList)) {
      OnSetFormData();
    }
  }, [historyList]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">Floor</td>
                    <td className="font-weight-bold">Actual Use</td>
                    <td className="font-weight-bold">Floor Area</td>
                    <td className="font-weight-bold">Market Value</td>
                    <td className="font-weight-bold">Remarks</td>
                  </tr>
                </thead>
                <tbody>
                  {_.isEmpty(floorAreaList) ? (
                    <tr className="w-100">
                      <td colSpan="5" className="text-center border-top p-4 text-muted">
                        This Section is Empty
                      </td>
                    </tr>
                  ) : (
                    floorAreaList.map(item => (
                      <tr key={item.id}>
                        <td className="history-color">{_.get(item, 'attributes.floor')}</td>
                        <td className="history-color">{_.get(item, 'attributes.actual_use') || ''}</td>
                        <td className="history-color">{_.get(item, 'attributes.area') || ''}</td>
                        <td className="history-color">PHP{' '}{formatNumberWithCommas(_.get(item, 'attributes.market_value') || 0)}</td>
                        <td className="history-color">{_.get(item, 'attributes.remarks') || ''}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <hr />
            <div className="col-12 mt-1">
              <span className="title-color">Breakdown of Costs</span>
            </div>
            <div className="row my-3 mx-2">
              <div className="d-flex">
                <table className="css-table table table-bordered table-sm mr-2 ml-2">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="200">
                        Cost of Additional Items
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'cost_of_additional_item_sub_total') || '0.00'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="200">
                        Sub-Total Adjustment
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'sub_total_adjustment')
                            ? parseFloat(
                              _.get(formData, 'sub_total_adjustment')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : '0.00'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="200">
                        Total Construction Cost
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'total_construction_cost') || '0.00'}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="css-table table table-bordered table-sm">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="200">
                        Depreciation Rate
                      </td>
                      <td width="150">
                        <span className="title-color">
                          {_.get(formData, 'depreciation_rate')
                            ? parseFloat(
                              _.get(formData, 'depreciation_rate')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : '0.00'} %
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="200">
                        Depreciation Cost
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'depreciation_cost') || '0.00'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="200">
                        Total % Depreciation Cost
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'total_percent_depreciation')
                            ? parseFloat(
                              _.get(formData, 'total_percent_depreciation')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : '0.00'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="200">
                        Market Value
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'market_value') || '0.00'}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

PropertyAppraisalTab.defaultProps = {
  historyInfo: {}
};

PropertyAppraisalTab.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  floorAreaList: PropTypes.instanceOf(Array).isRequired,
  getPropertyAppraisalLogs: PropTypes.instanceOf(Function).isRequired,
  historyList: PropTypes.instanceOf(Array).isRequired,
  historyInfo: PropTypes.instanceOf(Object),
  showPropertyAppraisalLogs: PropTypes.instanceOf(Function).isRequired,
  getFloorPlanLogs: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  historyList: _.get(api, `${c.GET_PROPERTY_APPRAISAL_LOGS}.list`) || [],
  floorAreaList: _.get(api, `${c.GET_FLOOR_PLAN_LOGS}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_PROPERTY_APPRAISAL_LOGS) > -1,
  appraisalInfo: _.get(api, `${c.SHOW_PROPERTY_APPRAISAL_LOGS}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PropertyAppraisalTab);
